import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CustomLoader = ({ message }) => {
  const theme = useTheme();
  const { t } = useTranslation(['workflow']);
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.mode === 'light' && 'rgba(255, 255, 255, 0.7)',
      }}
    >
      <CircularProgress />
      {message && (
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: '500',
            lineHeight: '20px',
            mt: 0,
            py: 1,
            backgroundColor: theme.palette.background.paper,
          }}
        >
          {t(message)}
        </Typography>
      )}
    </Box>
  );
};

export default CustomLoader;
